import React from 'react';
import ReactDom from 'react-dom';

import Base from './Base.jsx';

import DonutChart from '../Components/DonutChart/index.jsx';


class EntryPoint extends Base {
  id() {
    return 'cs-donut-chart';
  }

  renderElement(element) {
    var attribute = element.dataset.attribute;
    if (attribute) {
      var chartData = JSON.parse(attribute);
    }

    var data = chartData.map(dataItem => {
      return {
        value: dataItem.percent,
        name: `${dataItem.title} - ${dataItem.percent}%`
      }
    })

    return (
      <DonutChart chartData={data}/>
    );
  }
}


export default EntryPoint;

